module.exports = __webpack_public_path__ + "img/ferrari-sport.af265a41.jpg";